import { Component, inject, ChangeDetectionStrategy } from "@angular/core";
import { Router } from "@angular/router";
import {LanguageSelectionDialogComponent} from 'src/app/language-selection-dialog/language-selection-dialog.component';
import {TranslationSettingsService} from 'src/app/language-selection-dialog/translation-settings.service';
import {LanguageService} from 'src/app/shared/language.service';
import {MatDialog} from '@angular/material/dialog';

@Component({
    selector: "app-home",
    templateUrl: "./home.component.html",
    styleUrls: ["./home.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HomeComponent {
  private router = inject(Router);
  private readonly dialog = inject(MatDialog);
  private readonly languageService = inject(LanguageService);
  private readonly translationSettingsService = inject(TranslationSettingsService);

  onAreas() {
    this.router.navigate(["/areas"]);
  }
  onBranch() {
    this.router.navigate(["/branches"]);
  }

  onBranchAdmin() {
    this.router.navigate(["/branch-admins"]);
  }

  onTypes() {
    this.router.navigate(["/types"]);
  }

  onStatuses() {
    this.router.navigate(["/statuses"]);
  }

  onPriorities() {
    this.router.navigate(["/priorities"]);
  }

  onDepartments() {
    this.router.navigate(["/departments"]);
  }

  onProductCategories() {
    this.router.navigate(["/categories"]);
  }

  onFormTypes() {
    this.router.navigate(["/formtypes"]);
  }

  onChains() {
    this.router.navigate(["/chains"]);
  }

  onChainAdmins() {
    this.router.navigate(["/chain-admins"]);
  }

  onUserAttributes() {
    this.router.navigate(["/user-attributes"]);
  }

  onInstallationAttributes() {
    this.router.navigate(["/installation-attributes"]);
  }

  onLanguageSelection(): void {
    this.languageService.loadLanguages().subscribe((languages) => {
      const dialogRef = this.dialog.open(LanguageSelectionDialogComponent, {
        width: '500px',
        data: {
          languages,
          selectedLocales: this.translationSettingsService.selectedLocales()
        }
      });

      dialogRef.afterClosed().subscribe((selectedLocales: string[] | undefined) => {
        if (!selectedLocales) {
          return;
        }

        const selectedLanguages = languages.filter(lang =>
          selectedLocales.includes(lang.locale)
        );

        this.translationSettingsService.setSelectedLanguages(selectedLanguages);
      });
    });
  }
}
